import { render, staticRenderFns } from "./v-alerts.vue?vue&type=template&id=2f037503&"
import script from "./v-alerts.vue?vue&type=script&lang=js&"
export * from "./v-alerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports